import IconWrapper from "./../IconWrapper/IconWrapper";
import { ContaTipoLiquidacao } from "features/conta/typings";

interface FiltroTipoLiquidacaoProps {
  setSelectedEmailStatus: (id?: ContaTipoLiquidacao) => any;
  selectedEmailStatus?: ContaTipoLiquidacao;
}
function FiltroTipoLiquidacao({
  selectedEmailStatus,
  setSelectedEmailStatus,
}: FiltroTipoLiquidacaoProps) {
  const onSelectTipoStatus = (t?: ContaTipoLiquidacao) => {
    if (selectedEmailStatus === t) {
      setSelectedEmailStatus?.(undefined);
    } else {
      setSelectedEmailStatus?.(t);
    }
  };

  return (
    <>
      <IconWrapper
        onClick={() => onSelectTipoStatus?.()}
        selected={!selectedEmailStatus}
      >
        Todos
      </IconWrapper>

      <IconWrapper
        onClick={() => onSelectTipoStatus?.(ContaTipoLiquidacao.Manual)}
        selected={selectedEmailStatus === ContaTipoLiquidacao.Manual}
      >
        Manual
      </IconWrapper>

      <IconWrapper
        onClick={() => onSelectTipoStatus?.(ContaTipoLiquidacao.Automatica)}
        selected={selectedEmailStatus === ContaTipoLiquidacao.Automatica}
      >
        Automática Sistema
      </IconWrapper>
    </>
  );
}

export default FiltroTipoLiquidacao;
